var htmlToReactUnsuportedAttribs = {
    onmousedown: 'onMouseDown',
    onmouseup: 'onMouseUp',
};
export var camelCaseAttr = function () { return ({
    shouldPreprocessNode: function (node) {
        return node.attribs && (node.attribs['onmousedown'] || node.attribs['onmouseup']);
    },
    preprocessNode: function (node) {
        for (var key in htmlToReactUnsuportedAttribs) {
            if (node.attribs[key.toLowerCase()]) {
                node.attribs[htmlToReactUnsuportedAttribs[key]] = node.attribs[key];
                delete node.attribs[key];
            }
        }
    },
}); };
//# sourceMappingURL=camelCaseAttr.js.map